import React from "react";
import { StyledContainer } from "./styled";

const PageNotFound: React.FC = () => {
    return (<StyledContainer>PAGE NOT FOUND</StyledContainer>)
};

export default PageNotFound;
